module.exports = __webpack_public_path__ + "static/img/bg.b049b995.png";